// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"667":"a94ae028","843":"de595582"}[chunkId] + ".js";
};